import React, { useState } from 'react';
import { SignedIn, SignedOut, SignInButton, UserButton, useAuth } from '@clerk/clerk-react';
import '../styles/Header.css';
import logoDark from '../images/logo_dark.png';
import logoLight from '../images/logo_light.png';

const Header = ({ currentPage, onNavigate, isDarkMode, onToggleDarkMode }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isSignedIn } = useAuth();
  
  // Select appropriate logo based on theme
  const currentLogo = isDarkMode ? logoDark : logoLight;

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'manabase', label: 'Manabase Generator' },
    ...(isSignedIn ? [{ id: 'mydecks', label: 'My Decks' }] : []),
    { id: 'faq', label: 'FAQ' },
  ];

  const handleNavClick = (pageId) => {
    onNavigate(pageId);
    setMobileMenuOpen(false);
  };

  return (
    <header className="site-header">
      <div className="header-content">
        {/* Logo */}
        <div className="header-logo" onClick={() => handleNavClick('home')}>
          <img src={currentLogo} alt="EDH.Build Logo" className="logo-image" />
          <span className="logo-text">EDH.Build</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="header-nav desktop-nav">
          {navItems.map((item) => (
            <button
              key={item.id}
              className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
            >
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Right side actions */}
        <div className="header-actions">
          {/* Discord link */}
          <a
            href="https://discord.gg/QcyDrwD2BB"
            className="discord-link"
            target="_blank"
            rel="noopener noreferrer"
            title="Join our Discord!"
          >
            <svg className="discord-icon" viewBox="0 0 71 55" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M60.1 4.9A58.5 58.5 0 0045.4.2a.2.2 0 00-.2.1 40.8 40.8 0 00-1.8 3.7 54 54 0 00-16.2 0A37.4 37.4 0 0025.4.3a.2.2 0 00-.2-.1 58.4 58.4 0 00-14.7 4.6.2.2 0 00-.1 0A60 60 0 00.4 43.8a.2.2 0 000 .2 58.8 58.8 0 0017.7 9 .2.2 0 00.3-.1 42 42 0 003.6-5.9.2.2 0 00-.1-.3 38.8 38.8 0 01-5.5-2.6.2.2 0 01 0-.4l1.1-.9a.2.2 0 01.2 0 42 42 0 0035.6 0 .2.2 0 01.2 0l1.1.9a.2.2 0 010 .4 36.4 36.4 0 01-5.5 2.6.2.2 0 00-.1.3 47.2 47.2 0 003.6 5.9.2.2 0 00.3.1 58.6 58.6 0 0017.7-9 .2.2 0 000-.2A59.5 59.5 0 0049.5 4.9a.2.2 0 00-.1 0zM23.7 35.9c-3.4 0-6.2-3.1-6.2-7s2.8-7 6.2-7c3.5 0 6.3 3.2 6.2 7 0 3.9-2.7 7-6.2 7zm22.9 0c-3.4 0-6.2-3.1-6.2-7s2.7-7 6.2-7c3.5 0 6.3 3.2 6.2 7 0 3.9-2.7 7-6.2 7z"/>
            </svg>
            <span className="discord-text">Discord</span>
          </a>
          {/* Auth buttons */}
          <SignedOut>
            <SignInButton mode="modal">
              <button className="auth-button sign-in-btn">Sign In</button>
            </SignInButton>
          </SignedOut>
          <SignedIn>
            <UserButton 
              afterSignOutUrl="/"
              appearance={{
                elements: {
                  avatarBox: "user-avatar"
                }
              }}
            />
          </SignedIn>

          <button 
            onClick={onToggleDarkMode} 
            className="theme-toggle"
            aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {isDarkMode ? '☀️' : '🌙'}
          </button>

          {/* Mobile menu button */}
          <button 
            className={`mobile-menu-btn ${mobileMenuOpen ? 'open' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <nav className={`header-nav mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <button
            key={item.id}
            className={`nav-link ${currentPage === item.id ? 'active' : ''}`}
            onClick={() => handleNavClick(item.id)}
          >
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>
    </header>
  );
};

export default Header;
